import config from './config'

export function assignGlobal(update: AnyObject) {
  Object.assign(global, update)
}

assignGlobal({config})